import { DeliveryDatesFetchState } from '@app/pages/api/delivery-dates/types';
import { Item } from '@app/types/monolith/cart';
import type { CartCheckoutClient } from '../cartCheckoutClient';
import { DispatchActionsType, ErrorCode, StateDispatch } from './types';

// Cache layer to be introduced here in future PR
export const refreshCart = async (
  client: CartCheckoutClient,
  dispatch: StateDispatch,
  deliveryDatesFetchState?: DeliveryDatesFetchState
) => {
  dispatch({ type: DispatchActionsType.SET_CART_LOADING, payload: true });

  await client
    .fetchCartAndUpdateShippingCountry()
    .then(async (cart) => {
      dispatch({ type: DispatchActionsType.SET_CART, payload: cart });
      dispatch({
        type: DispatchActionsType.SET_DELIVERY_DATES_LOADING,
        payload: true,
      });

      const productTypeIds = getUniqueProductTypeIds(cart.items);

      // we have successfully loaded the cart, we can now fetch delivery dates
      await client
        .fetchDeliveryDates({
          countryCode: cart.summary.estimated_shipping.country_code,
          productTypeIds,
          fetchState: deliveryDatesFetchState,
        })
        .then((deliveryDatesData) => {
          dispatch({
            type: DispatchActionsType.SET_DELIVERY_DATES,
            payload: deliveryDatesData,
          });
        });
    })
    .catch((error) => {
      dispatch({
        type: DispatchActionsType.SET_ERRORS,
        payload: [
          {
            code: ErrorCode.CART_FETCH_ERROR,
            severity: 'critical',
          },
        ],
      });

      throw error;
    });
};

export const getUniqueProductTypeIds = (lineItems: Item[]): string[] =>
  Array.from(
    new Set(
      lineItems.map((item) => item.product_type_id || '').filter((id) => id)
    )
  );
